var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.footers),function(title,type,index){return [(index > 0)?_c('hr',{staticClass:"gray-200"}):_vm._e(),_c('TestSection',{attrs:{"subtitle":title}}),_c('UpsellingFooter',{staticClass:"text-center",attrs:{"type":type}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }